export const NOTIFICATION_TYPES = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

export const NOTIFICATION_TYPE_LABELS = {
  [NOTIFICATION_TYPES.INFO]: 'Info',
  [NOTIFICATION_TYPES.WARNING]: 'Warning',
  [NOTIFICATION_TYPES.ERROR]: 'Error',
};

export const NOTIFICATION_TYPE_FILTER_OPTIONS = [
  { value: 'ALL', label: 'All' },
  { value: NOTIFICATION_TYPES.INFO, label: 'Info' },
  { value: NOTIFICATION_TYPES.WARNING, label: 'Warning' },
  { value: NOTIFICATION_TYPES.ERROR, label: 'Error' },
];

export const NOTIFICATION_CHANNELS = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  BOTH: 'BOTH',
};

export const NOTIFICATION_CHANNEL_LABELS = {
  [NOTIFICATION_CHANNELS.EMAIL]: 'Email',
  [NOTIFICATION_CHANNELS.PHONE]: 'Phone push',
  [NOTIFICATION_CHANNELS.BOTH]: 'Email and phone',
};

export const NOTIFICATION_CHANNEL_FILTER_OPTIONS = [
  { value: 'ALL', label: 'All' },
  { value: NOTIFICATION_CHANNELS.EMAIL, label: 'Email' },
  { value: NOTIFICATION_CHANNELS.PHONE, label: 'Phone push' },
  { value: NOTIFICATION_CHANNELS.BOTH, label: 'Email and phone' },
];

export const NOTIFICATION_READ_FILTERS = {
  ALL: 'ALL',
  UNREAD: 'UNREAD',
  READ: 'READ',
};

export const NOTIFICATION_READ_FILTER_OPTIONS = [
  { value: NOTIFICATION_READ_FILTERS.ALL, label: 'All' },
  { value: NOTIFICATION_READ_FILTERS.UNREAD, label: 'Unread' },
  { value: NOTIFICATION_READ_FILTERS.READ, label: 'Read' },
];

export const NOTIFICATION_TYPE_BADGE_CLASSNAMES = {
  [NOTIFICATION_TYPES.INFO]: 'bg-blue-400/10 text-blue-300 ring-blue-400/20',
  [NOTIFICATION_TYPES.WARNING]: 'bg-amber-400/10 text-amber-300 ring-amber-400/20',
  [NOTIFICATION_TYPES.ERROR]: 'bg-red-400/10 text-red-300 ring-red-400/20',
};

export const NOTIFICATIONS_PAGE_SIZE = 10;
export const NOTIFICATION_DROPDOWN_LIMIT = 5;
export const NOTIFICATION_BADGE_MAX = 99;
